import { MultimediaFormFields } from '@/components/question/forms/multimedia/MultimediaForm';
import { questionGenerator } from '@/data/generators/questionGenerator';
import { Question, QuestionTypeEnum } from '@/models/Question';
import { normalizeTranslatableField } from '@/utils/translatable-field/normalizeTranslatableField';

export default function adapterMultimediaForm(
  multimedia: MultimediaFormFields,
): Question {
  return questionGenerator({
    title: normalizeTranslatableField(multimedia.title),
    context: normalizeTranslatableField(multimedia.context),
    type: QuestionTypeEnum.TEXT,
  });
}
